import { gsap } from 'gsap';

export function tab() {
	function getHashID(hashIDName) {
		if (hashIDName) {
			// タブ設定
			document.querySelectorAll('.js-tab-link').forEach(function (element) {
				var idName = element.getAttribute('href'); // タブ内のaタグのリンク名を取得
				if (idName === hashIDName) {
					// リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じかをチェック
					var parentElm = element.parentElement; // タブ内のaタグの親要素（li）を取得
					document.querySelectorAll('.js-tab-list').forEach(function (li) {
						li.classList.remove('active'); // タブ内のliについているactiveクラスを取り除く
					});
					parentElm.classList.add('active'); // リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
					// 表示させるエリア設定
					document.querySelectorAll('.js-tab-area').forEach(function (area) {
						area.classList.remove('is-active'); // もともとついているis-activeクラスを取り除く
					});
					document.querySelector(hashIDName).classList.add('is-active'); // 表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加
				}
			});
		}
	}

	// タブをクリックしたら
	document.querySelectorAll('.js-tab-link').forEach(function (element) {
		element.addEventListener('click', function (event) {
			var idName = element.getAttribute('href'); // タブ内のリンク名を取得
			getHashID(idName); // 設定したタブの読み込み
			event.preventDefault(); // aタグを無効にする
		});
	});

	// 上記の動きをページが読み込まれたらすぐに動かす
	window.addEventListener('load', function () {
		const firstTabList = document.querySelector('.js-tab-list:first-of-type');
		const firstTabArea = document.querySelector('.js-tab-area:first-of-type');

		if (firstTabList) {
			firstTabList.classList.add('active'); // 最初のliにactiveクラスを追加
		}

		if (firstTabArea) {
			firstTabArea.classList.add('is-active'); // 最初の.areaにis-activeクラスを追加
		}

		var hashName = location.hash; // リンク元の指定されたURLのハッシュタグを取得
		getHashID(hashName); // 設定したタブの読み込み
	});

	document.addEventListener('DOMContentLoaded', function () {
		gsap.config({ nullTargetWarn: false });

		const mobileTitle = document.querySelector('.js-mobile-title');
		if (mobileTitle) {
			mobileTitle.addEventListener('click', function (event) {
				event.preventDefault();

				gsap.to('.js-hidden-title', {
					autoAlpha: 1,
					display: 'block',
					duration: 0.5,
				});
			});
		}
	});

	// 実績ページのタブ
	document.addEventListener('DOMContentLoaded', function () {
		const yearTabs = document.querySelectorAll('.js-year-list li');
		const yearContents = document.querySelectorAll('.js-year-content');

		yearTabs.forEach((tab) => {
			tab.addEventListener('click', function () {
				const year = this.getAttribute('data-year');

				// Remove active class from all tabs and contents
				yearTabs.forEach((t) => t.classList.remove('is-active'));
				yearContents.forEach((content) => content.classList.remove('is-active'));

				// Add active class to the clicked tab and corresponding content
				this.classList.add('is-active');
				document.querySelector(`.js-year-content[data-year="${year}"]`).classList.add('is-active');

				// Add active class to the corresponding year tab
				document.querySelector(`.js-year-list li[data-year="${year}"]`).classList.add('is-active');
			});
		});
	});
}

// 採用情報ページ
document.addEventListener('DOMContentLoaded', function () {
	// メインタブの切り替え
	const tabItems = document.querySelectorAll('.p-recruit-recruit__tab-item');
	const tabContents = document.querySelectorAll('.p-recruit-recruit__tab-content');

	// メインタブの初期化
	const activeTab = document.querySelector('.p-recruit-recruit__tab-item.is-active');
	if (activeTab) {
		const tabId = activeTab.getAttribute('data-tab');
		const activeContent = document.getElementById(tabId);
		if (activeContent) {
			activeContent.classList.add('is-active'); // アクティブなタブのみ表示
		}
	}

	tabItems.forEach((item) => {
		item.addEventListener('click', function () {
			const tabId = this.getAttribute('data-tab');

			// タブのアクティブ状態を切り替え
			tabItems.forEach((i) => i.classList.remove('is-active'));
			this.classList.add('is-active');

			// コンテンツの表示を切り替え
			tabContents.forEach((content) => content.classList.remove('is-active'));
			const activeContent = document.getElementById(tabId);
			activeContent.classList.add('is-active');

			// キャリアタブの初期化
			const careerTabItems = activeContent.querySelectorAll('.p-recruit-recruit__career-tab-item');
			const careerTabContents = activeContent.querySelectorAll('.p-recruit-recruit__career-tab-content');

			careerTabItems.forEach((i) => i.classList.remove('is-active'));
			careerTabContents.forEach((content) => content.classList.remove('is-active'));

			const activeCareerTab = activeContent.querySelector('.p-recruit-recruit__career-tab-item');
			if (activeCareerTab) {
				const careerTabId = activeCareerTab.getAttribute('data-tab');
				activeCareerTab.classList.add('is-active');
				const activeCareerContent = document.getElementById(careerTabId);
				if (activeCareerContent) {
					activeCareerContent.classList.add('is-active');
				}
			}
		});
	});

	// キャリアアップタブの切り替え
	const careerTabItems = document.querySelectorAll('.p-recruit-recruit__career-tab-item');
	const careerTabContents = document.querySelectorAll('.p-recruit-recruit__career-tab-content');

	careerTabItems.forEach((item) => {
		item.addEventListener('click', function () {
			const careerTabId = this.getAttribute('data-tab');

			// キャリアタブのアクティブ状態を切り替え
			careerTabItems.forEach((i) => i.classList.remove('is-active'));
			this.classList.add('is-active');

			// キャリアコンテンツの表示を切り替え
			careerTabContents.forEach((content) => content.classList.remove('is-active'));
			document.getElementById(careerTabId).classList.add('is-active');
		});
	});
});
